import { call, put, takeLatest } from 'typed-redux-saga/macro';
import { eventsActionTypes } from '../ducks/events';
import { memberApi } from '../../lib/api';

function* getAllEventsRequest({ payload: { userId, category, dateFrom, dateTo } }: any) {
  yield put({
    type: eventsActionTypes.SET_LOADING,
    payload: true,
  });
  try {
    const req: any = yield* call(memberApi.getCalendarEvents, {
      userId,
      category,
      dateFrom,
      dateTo,
    });
    yield put({
      type: eventsActionTypes.GET_ALL_EVENTS_SUCCESS,
      payload: req.data.data,
    });
  } catch {}

  yield put({
    type: eventsActionTypes.SET_LOADING,
    payload: false,
  });
}

function* eventsSaga() {
  yield takeLatest(eventsActionTypes.GET_ALL_EVENTS_REQUEST, getAllEventsRequest);
}

export default eventsSaga;
